import { isEmpty, isNil, size } from 'lodash';

export const isRequired = (value) => !isNil(value) && isEmpty(value);
export const isMinimumLength = (value, length) => !isNil(value) && (size(value) < length);
export const isMatching = (value, otherValue) => !isNil(value) && (value !== otherValue);
export const isEmail = (value) => !isNil(value) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value);
